import { render, staticRenderFns } from "./MobileCommunityHealthInfo.vue?vue&type=template&id=7cad0525&scoped=true&"
import script from "./MobileCommunityHealthInfo.vue?vue&type=script&lang=js&"
export * from "./MobileCommunityHealthInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cad0525",
  null
  
)

export default component.exports